import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import { createCourse, submitCourse, COURSES_URL } from '../../Services/Services';
import './AddCourse.css';
import { v4 as uuidv4 } from 'uuid';
import { css } from "@emotion/react";
import { useTranslation } from 'react-i18next';
import axios from 'axios';


const AddCourse = () => {
  const { t } = useTranslation();
  const categoryMapping = {
    'Web Development': 'WEB_DEVELOPMENT',
    'Mobile Development': 'MOBILE_DEVELOPMENT',
    'Programming Languages': 'PROGRAMMING',
    'Game Development': 'GAME_DEVELOPMENT',
    'Database Design & Development': 'DATABASE_DESIGN_DEVELOPMENT',
    'Software Testing': 'SOFTWARE_TESTING',
    'Software Engineering': 'SOFTWARE_ENGINEERING',
    'Software Development Tools': 'SOFTWARE_DEV_TOOLS',
    'No-Code Development': 'NO_CODE_DEVELOPMENT',
    'Entrepreneurship': 'ENTREPRENEURSHIP',
    'Sales': 'SALES',
    'Leadership & Management': 'LEADERSHIP_MANAGEMENT',
    'Business Analytics': 'BUSINESS_ANALYTICS',
    'Financial Accounting': 'FINANCIAL_ACCOUNTING',
    'Corporate Finance': 'CORPORATE_FINANCE',
    'Personal Finance': 'PERSONAL_FINANCE',
    'Cloud Computing': 'CLOUD_COMPUTING',
    'Cybersecurity': 'CYBERSECURITY',
    'Networking': 'NETWORKING',
    'Graphic Design': 'GRAPHIC_DESIGN',
    'UI/UX Design': 'UI_UX_DESIGN',
    '3D & Animation': 'THREE_D_ANIMATION',
    'Digital Marketing': 'DIGITAL_MARKETING',
    'Affiliate Marketing': 'AFFILIATE_MARKETING',
    'Branding': 'BRANDING',
    'Business & Enterprise Software':'BUSINESS & ENTERPRISE SOFTWARE'
  };

  const subcategoryMapping = {
    'Web Development': {
      'JavaScript': 'JAVASCRIPT',
      'React': 'REACT',
      'HTML/CSS': 'HTML_CSS',
      'MERN': 'MERN',
      'TypeScript': 'TYPESCRIPT',
      'Node.js': 'NODE_JS',
      'Angular': 'ANGULAR',
      'Vue.js': 'VUE_JS',
      'Svelte': 'SVELTE'
    },
    'Mobile Development': {
      'Flutter': 'FLUTTER',
      'React Native': 'REACT_NATIVE',
      'Swift': 'SWIFT',
      'Kotlin': 'KOTLIN',
      'Android Studio': 'ANDROID_STUDIO',
      'iOS Development': 'IOS_DEVELOPMENT',
      'Xamarin': 'XAMARIN',
      'Ionic': 'IONIC'
    },
    'Programming Languages': {
      'Python': 'PYTHON',
      'Java': 'JAVA',
      'C++': 'C_PLUS_PLUS',
      'JavaScript': 'JAVASCRIPT_LANG',
      'Go': 'GO',
      'Ruby': 'RUBY',
      'Rust': 'RUST',
      'Swift': 'SWIFT_LANG',
      'C#': 'C_SHARP',
      'PHP': 'PHP'
    },
    'Game Development': {
      'Unity': 'UNITY',
      'Unreal Engine': 'UNREAL_ENGINE',
      'C#': 'C_SHARP',
      'Game Design': 'GAME_DESIGN',
      '3D Modeling': 'THREE_D_MODELING',
      'AR/VR Development': 'AR_VR_DEVELOPMENT',
      'Blender': 'BLENDER',
      'Godot': 'GODOT'
    },
    'Database Design & Development': {
      'SQL': 'SQL',
      'MongoDB': 'MONGODB',
      'PostgreSQL': 'POSTGRESQL',
      'Firebase': 'FIREBASE',
      'Database Architecture': 'DATABASE_ARCHITECTURE',
      'NoSQL': 'NOSQL',
      'GraphQL': 'GRAPHQL',
      'Cassandra': 'CASSANDRA'
    },
    'Software Testing': {
      'Selenium': 'SELENIUM',
      'Unit Testing': 'UNIT_TESTING',
      'Test Automation': 'TEST_AUTOMATION',
      'API Testing': 'API_TESTING',
      'JUnit': 'JUNIT',
      'Cucumber': 'CUCUMBER',
      'Cypress': 'CYPRESS',
      'Appium': 'APPIUM'
    },
    'Software Engineering': {
      'Software Design Patterns': 'SOFTWARE_DESIGN_PATTERNS',
      'Microservices': 'MICROSERVICES',
      'DevOps': 'DEVOPS',
      'Systems Architecture': 'SYSTEMS_ARCHITECTURE',
      'Agile': 'AGILE',
      'Scrum': 'SCRUM',
      'CI/CD': 'CI_CD'
    },
    'Software Development Tools': {
      'Git': 'GIT',
      'Docker': 'DOCKER',
      'Kubernetes': 'KUBERNETES',
      'Jenkins': 'JENKINS',
      'CI/CD': 'CI_CD',
      'IDEs': 'IDES',
      'Terraform': 'TERRAFORM',
      'Vagrant': 'VAGRANT',
      'GitLab': 'GITLAB'
    },
    'No-Code Development': {
      'Webflow': 'WEBFLOW',
      'Bubble': 'BUBBLE',
      'Adalo': 'ADALO',
      'Zapier': 'ZAPIER',
      'Airtable': 'AIRTABLE',
      'Integromat': 'INTEGROMAT',
      'Glide': 'GLIDE',
      'Thunkable': 'THUNKABLE'
    },
    'Entrepreneurship': {
      'Startups': 'STARTUPS',
      'Funding': 'FUNDING',
      'Business Models': 'BUSINESS_MODELS',
      'Product Management': 'PRODUCT_MANAGEMENT',
      'Lean Startup': 'LEAN_STARTUP',
      'Pitching': 'PITCHING',
      'Scaling': 'SCALING'
    },
    'Sales': {
      'B2B Sales': 'B2B_SALES',
      'Negotiation': 'NEGOTIATION',
      'Lead Generation': 'LEAD_GENERATION',
      'CRM': 'CRM',
      'Sales Funnels': 'SALES_FUNNELS',
      'Cold Calling': 'COLD_CALLING',
      'Email Marketing': 'EMAIL_MARKETING'
    },
    'Leadership & Management': {
      'Team Management': 'TEAM_MANAGEMENT',
      'Leadership Skills': 'LEADERSHIP_SKILLS',
      'Agile Leadership': 'AGILE_LEADERSHIP',
      'Strategic Thinking': 'STRATEGIC_THINKING',
      'Project Management': 'PROJECT_MANAGEMENT',
      'OKRs': 'OKRS'
    },
    'Business Analytics': {
      'Data Analysis': 'DATA_ANALYSIS',
      'Power BI': 'POWER_BI',
      'Tableau': 'TABLEAU',
      'Financial Modeling': 'FINANCIAL_MODELING',
      'Business Intelligence': 'BUSINESS_INTELLIGENCE',
      'Data Visualization': 'DATA_VISUALIZATION',
      'Excel': 'EXCEL'
    },
    'Financial Accounting': {
      'Balance Sheets': 'BALANCE_SHEETS',
      'Income Statements': 'INCOME_STATEMENTS',
      'GAAP': 'GAAP',
      'IFRS': 'IFRS',
      'Auditing': 'AUDITING',
      'Bookkeeping': 'BOOKKEEPING',
      'Taxation': 'TAXATION',
      'QuickBooks': 'QUICKBOOKS'
    },
    'Corporate Finance': {
      'Capital Budgeting': 'CAPITAL_BUDGETING',
      'Corporate Valuation': 'CORPORATE_VALUATION',
      'Risk Management': 'RISK_MANAGEMENT',
      'Mergers & Acquisitions': 'MERGERS_ACQUISITIONS',
      'Investment Banking': 'INVESTMENT_BANKING',
      'IPO': 'IPO'
    },
    'Personal Finance': {
      'Budgeting': 'BUDGETING',
      'Saving': 'SAVING',
      'Investing': 'INVESTING',
      'Retirement Planning': 'RETIREMENT_PLANNING',
      'Financial Independence': 'FINANCIAL_INDEPENDENCE',
      'Real Estate': 'REAL_ESTATE',
      'Stocks': 'STOCKS'
    },
    'Cloud Computing': {
      'AWS': 'AWS',
      'Azure': 'AZURE',
      'Google Cloud': 'GOOGLE_CLOUD',
      'Kubernetes': 'KUBERNETES',
      'Serverless Architecture': 'SERVERLESS_ARCHITECTURE',
      'Cloud Security': 'CLOUD_SECURITY',
      'DevOps': 'DEVOPS',
      'OpenShift': 'OPENSHIFT'
    },
    'Cybersecurity': {
      'Ethical Hacking': 'ETHICAL_HACKING',
      'Penetration Testing': 'PENETRATION_TESTING',
      'Network Security': 'NETWORK_SECURITY',
      'Cryptography': 'CRYPTOGRAPHY',
      'Cyber Threats': 'CYBER_THREATS',
      'Firewalls': 'FIREWALLS',
      'SOC': 'SOC'
    },
    'Networking': {
      'CCNA': 'CCNA',
      'Network Protocols': 'NETWORK_PROTOCOLS',
      'Cisco': 'CISCO',
      'SDN': 'SDN',
      'Network Security': 'NETWORK_SECURITY',
      'Routing': 'ROUTING',
      'VPN': 'VPN',
      'Switching': 'SWITCHING'
    },
    'Graphic Design': {
      'Photoshop': 'PHOTOSHOP',
      'Illustrator': 'ILLUSTRATOR',
      'InDesign': 'INDESIGN',
      'Canva': 'CANVA',
      'Typography': 'TYPOGRAPHY',
      'Color Theory': 'COLOR_THEORY',
      'Logo Design': 'LOGO_DESIGN',
      'Branding': 'BRANDING'
    },
    'UI/UX Design': {
      'Figma': 'FIGMA',
      'Adobe XD': 'ADOBE_XD',
      'Sketch': 'SKETCH',
      'Wireframing': 'WIREFRAMING',
      'Prototyping': 'PROTOTYPING',
      'User Research': 'USER_RESEARCH',
      'Usability Testing': 'USABILITY_TESTING'
    },
    '3D & Animation': {
      'Blender': 'BLENDER',
      'Maya': 'MAYA',
      'Cinema 4D': 'CINEMA_4D',
      'After Effects': 'AFTER_EFFECTS',
      'Motion Graphics': 'MOTION_GRAPHICS',
      'Character Animation': 'CHARACTER_ANIMATION'
    },
    'Digital Marketing': {
      'SEO': 'SEO',
      'Google Ads': 'GOOGLE_ADS',
      'Facebook Ads': 'FACEBOOK_ADS',
      'Content Marketing': 'CONTENT_MARKETING',
      'Social Media Marketing': 'SOCIAL_MEDIA_MARKETING',
      'PPC': 'PPC',
      'Influencer Marketing': 'INFLUENCER_MARKETING'
    },
    'Affiliate Marketing': {
      'Affiliate Networks': 'AFFILIATE_NETWORKS',
      'Commission Tracking': 'COMMISSION_TRACKING',
      'Product Reviews': 'PRODUCT_REVIEWS',
      'SEO for Affiliates': 'SEO_FOR_AFFILIATES',
      'Email Campaigns': 'EMAIL_CAMPAIGNS'
    },
    'Branding': {
      'Brand Strategy': 'BRAND_STRATEGY',
      'Brand Identity': 'BRAND_IDENTITY',
      'Brand Voice': 'BRAND_VOICE',
      'Customer Engagement': 'CUSTOMER_ENGAGEMENT',
      'Rebranding': 'REBRANDING',
      'PR': 'PR',
      'Storytelling': 'STORYTELLING'
    },
    'Business & Enterprise Software':{
      'Sap':'SAP',
      'Oracle ERP':'ORACLE_ERP',
      'Microsoft Dynamics':'MICROSOFT_DYNAMICS',
      'Workday':'WORKDAY',
      'NetSuite':'NETSUITE'
    }
  };

  const levels = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'];
  const languages = ['ENGLISH', 'TELUGU', 'HINDI', 'MALAYALAM', 'TAMIL'];
  const paymentTypes = ['ONE_TIME', 'PERCENTAGE'];

  const paymentTypeLabels = {
    'ONE_TIME': 'One Time',
    'PERCENTAGE': 'Percentage / Commission-Based'
  }
  const categories = Object.keys(categoryMapping);
  const [progress, setProgress] = useState(0);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [category, setCategory] = useState('');
  const [subcategory, setSubcategory] = useState('');
  const [level, setLevel] = useState('');
  const [language, setLanguage] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [courseId, setCourseId] = useState('');
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const fullName = localStorage.getItem('fullName');
  const [showTooltip, setShowTooltip] = useState(false);

  const [sections, setSections] = useState([{ sectionTitle: '', lessons: [{ title: '', video: null }] }]);

  const handleVideoChange = (sectionIndex, lessonIndex, e) => {
    console.log('sectionIndex:', sectionIndex, 'lessonIndex:', lessonIndex, 'sections:', sections);

    const newVideo = e.target.files ? e.target.files[0] : null;
    if (!newVideo) {
      return;
    }

    if (
      sections[sectionIndex] &&
      sections[sectionIndex].lessons &&
      sections[sectionIndex].lessons[lessonIndex]
    ) {
      const newSections = sections.map((section, secIdx) => {
        if (secIdx !== sectionIndex) return section;

        return {
          ...section,
          lessons: section.lessons.map((lesson, lesIdx) => {
            if (lesIdx !== lessonIndex) return lesson;

            return {
              ...lesson,
              video: newVideo,
              videoPreview: URL.createObjectURL(newVideo),
            };
          }),
        };
      });

      setSections(newSections);
    } else {
      console.error("Invalid sectionIndex or lessonIndex:", sectionIndex, lessonIndex);
    }
  };

  const handleAddLesson = (sectionIndex) => {
    const newSections = [...sections];
    newSections[sectionIndex].lessons.push({ title: '', video: null });
    setSections(newSections);
  };

  const handleRemoveLesson = (sectionIndex, lessonIndex) => {
    const newSections = [...sections];
    newSections[sectionIndex].lessons.splice(lessonIndex, 1);
    setSections(newSections);
  };

  const handleAddSection = () => {
    setSections([...sections, { sectionTitle: '', lessons: [{ title: '', video: null }] }]);
    setActiveSectionIndex(sections.length);
  };

  const handleRemoveSection = (index) => {
    const newSections = sections.filter((_, i) => i !== index);
    setSections(newSections);
    setActiveSectionIndex(Math.max(0, activeSectionIndex - 1));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }
    toast.dismiss();


    if (file.size > 10 * 1024 * 1024) {
      toast.error("Please upload an image smaller than 10 MB.");
    } else {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
      toast.success("Image selected successfully.");
    }
  };

  const handleSubmit = async (e, isConfirmed) => {
    e.preventDefault();

    toast.dismiss();

    setLoading(true);

    const toastId = toast.success("The upload is in progress and may take a few minutes. Please wait until it's successfully uploaded", {
      autoClose: false,
    });


    const taskId = uuidv4();

    const eventSource = new EventSource(`${COURSES_URL}/courseProgress/track/${taskId}`);

    eventSource.addEventListener('progress', (event) => {
      const progressData = event.data;

      const numericProgress = parseFloat(progressData.replace('%', '').trim());

      if (!isNaN(numericProgress)) {
        setProgress(numericProgress);
        console.log(`Current progress: ${numericProgress}%`);
      }
    });

    eventSource.onopen = () => {
      console.log('Connection established');
    };

    eventSource.onerror = (error) => {
      console.error('Error occurred while receiving progress updates:', error);
      eventSource.close();
    };

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("image", image);
    formData.append('category', categoryMapping[category] || category);
    formData.append('subCategory', subcategoryMapping[category]?.[subcategory] || subcategory);
    formData.append('level', level);
    formData.append('instructorId', userId);
    formData.append('language', language);
    formData.append('InstructorName', fullName);
    formData.append('paymentType', paymentType);
    formData.append('taskId', taskId);

    sections.forEach((section, sectionIndex) => {
      formData.append(`sections[${sectionIndex}].title`, section.sectionTitle);
      section.lessons.forEach((lesson, lessonIndex) => {
        if (lesson.title && lesson.video) {
          formData.append(
            `sections[${sectionIndex}].lessons[${lessonIndex}].title`,
            lesson.title
          );
          formData.append(
            `sections[${sectionIndex}].lessons[${lessonIndex}].video`,
            lesson.video
          );
        }
      });
    });

    try {
      let response;
      if (isConfirmed) {
        response = await submitCourse(formData);
      } else {
        response = await createCourse(formData);
      }

      setLoading(false);
      toast.dismiss(toastId);

      toast.dismiss();
      if (response.status === 201) {
        toast.success(
          isConfirmed ? "Course submitted successfully!" : "Course created successfully!"
        );
        eventSource.close();
        const course_Id = response?.data?.data;
        // setCourseId(course_Id);
        handleQuiz(course_Id);
        setShowModal(true);
      } else {
        toast.error("An error occurred while processing the course.");
      }
    } catch (error) {
      setLoading(false);
      toast.dismiss(toastId);

      toast.dismiss();
      if (error.response) {
        if (error.response.status === 500) {
          const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
          toast.error(`${errorMessage}`);
        } else if (error.response.status === 400) {
          const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
          toast.error(`${errorMessage}`);
        } else {
          toast.error("An unexpected error occurred while processing the request.");
        }
      } else {
        toast.error("An unknown error occurred.");
      }
    }
    finally {
      toast.dismiss(toastId);
    }
  };


  const extractLastLine = (errorData) => {
    if (typeof errorData !== 'string') {
      return "Invalid error data format.";
    }

    const lines = errorData.split('\n');
    let lastLine;

    if (lines.some(line => line.toLowerCase().includes('video with the same name already exists'))) {
      lastLine = lines[lines.length - 1];
    }
    else if (lines.some(line => line.toLowerCase().includes('video'))) {
      lastLine = lines[lines.length - 2];
    } else if (lines.some(line => line.toLowerCase().includes('image'))) {
      lastLine = lines[lines.length - 3];
    } else {
      lastLine = lines[lines.length - 1];
    }

    return lastLine || "An unexpected error occurred.";
  };

  // const handleConfirmQuizCreation = () => {
  //   navigate(`/quiz-creation/${courseId}`);
  //   setShowModal(false);
  // };

  const handleCancelQuizCreation = () => {
    navigate('/instructor');
    setShowModal(false);
  };
  const handleOpenConfirmationPopup = (e) => {

    const form = document.querySelector("form");

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    toast.dismiss();

    if (description.length < 50) {
      toast.error("Description must be at least 50 characters long.");
      return;
    }

    const wordCount = description.split(/\s+/).filter(Boolean).length;
    if (wordCount < 10) {
      toast.error("Description must be at least 10 words long.");
      return;
    }

    if (questions.length < 2) {
      toast.error("Please add a minimum of 2 quizzes.");
      return;
    }

    setConfirmationPopup(true);
  };

  const handleCloseConfirmationPopup = (isConfirmed) => {


    if (isConfirmed) {
      handleSubmit({ preventDefault: () => { } }, true);
    } else {
      handleSubmit({ preventDefault: () => { } }, false);
    }
    setConfirmationPopup(false);
  };

  const FancyProgressLoader = ({ progress }) => (
    <div className="loading-overlay">
      <div className="spinner-wrapper">
        <ClipLoader
          color="#F09D37"
          loading={true}
          size={70}
          css={css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          `}
        />
        <div className="percentage-wrapper" style={{ position: "absolute", top: "44%", left: "50%", transform: "translate(-50%, -50%)", color: "#F09D37" }}>
          <span className="percentage" style={{ fontSize: "17px" }}>
            {progress !== null ? Math.round(progress) + "%" : "0%"}
          </span>
        </div>
        <p className='loading-note'>Please wait until all videos have been uploaded. This may take some time. Do not refresh the screen, as this will cancel the upload.</p>

      </div>
    </div>
  );

  const instructorId = localStorage.getItem("userId");

  const [questions, setQuestions] = useState([{
    question: '',
    answers: [
      { answer: '', correct: false },
      { answer: '', correct: false },
      { answer: '', correct: false },
      { answer: '', correct: false }
    ]
  }]);


  const handleQuestionChange = (index, e) => {
    const newQuestions = [...questions];
    newQuestions[index].question = e.target.value;
    setQuestions(newQuestions);
  };

  const handleAnswerChange = (qIndex, aIndex, e) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].answers[aIndex].answer = e.target.value;
    setQuestions(newQuestions);
  };

  const handleCorrectAnswerChange = (qIndex, aIndex) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].answers.forEach((answer, index) => {
      answer.correct = index === aIndex;
    });
    setQuestions(newQuestions);
  };

  const handleAddQuestion = () => {
    setQuestions([...questions, {
      question: '',
      answers: [
        { answer: '', correct: false },
        { answer: '', correct: false },
        { answer: '', correct: false },
        { answer: '', correct: false }
      ]
    }]);
  };

  const handleRemoveQuestion = (index) => {
    const newQuestions = questions.filter((_, qIndex) => qIndex !== index);
    setQuestions(newQuestions);
  };

  const handleQuiz = async (course_Id) => {
    //  const toastId = toast.success(t('UploadingQuiz',{autoClose: false}));
    const payload = {
      title,
      instructorId,
      courseId: course_Id,
      questions,
    };

    try {
      const response = await axios.post(`${COURSES_URL}/quizzes`, payload);
      setLoading(false);
      if (response.status === 201) {
        // toast.success(t('QuizAddedSuccess'));
      } else {
        toast.error(t('QuizAddedFail'));
      }
    } catch (error) {
      // toast.dismiss(toastId);
      setLoading(false);
      toast.error(t('Unable to add the quiz. Please try again later'));
    }
    finally { }
    // toast.dismiss(toastId);
  };

  return (
    <div className="course-form-container">
      <h2>Add New Course</h2>
      <form onSubmit={handleSubmit}>
        {loading && (
          <div className="loading">
            <FancyProgressLoader progress={progress} />
          </div>
        )}
        {/* {loading && (
          <div className="loading-overlay">
            <ClipLoader color="#333333" loading={loading} size={30} />
            <div className="progress-bar">
              <progress value={progress} max="100"></progress>
              <span>{Math.round(progress)}%</span>
            </div>
          </div>
        )} */}

        <div>
          <label>Course Title</label>
          <input
            type="text"
            name="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <p className='price-note'> The course title will appear on the course page for users, so please provide an appropriate title </p>

        </div>

        <div>
          <label>Description</label>
          <textarea
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={650}
            required
          />
          <p className='price-note'>
            The description should be clear and informative, visible on the course page for users before enrolling. It must be between 50 and 650 characters and contain at least 10 words.          </p>
        </div>

        <div>
          <label>Price</label>
          <input
            type="number"
            name="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
            min="0"
          />
          <p className='price-note'>The course price will be validated and finalized by the Skillzverse team.</p>
        </div>

        <div>
          <label>Payment Type</label>
          <select
            name="paymentType"
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
            required
          >
            <option value="">Select Payment Type</option>
            {paymentTypes.map((pay) => (
              <option key={pay} value={pay}>
                {paymentTypeLabels[pay]}
              </option>
            ))}
          </select>
        </div>


        <div>
          <label>Category</label>
          <select
            name="category"
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
              setSubcategory('');
            }}
            required
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Subcategory</label>
          <select
            name="subcategory"
            value={subcategory}
            onChange={(e) => setSubcategory(e.target.value)}
            required
            disabled={!category}
          >
            <option value="">Select Subcategory</option>
            {category && subcategoryMapping[category] && Object.keys(subcategoryMapping[category]).map((subcat) => (
              <option key={subcat} value={subcat}>
                {subcat}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Level</label>
          <select
            name="level"
            value={level}
            onChange={(e) => setLevel(e.target.value)}
            required
          >
            <option value="">Select Level</option>
            {levels.map((lvl) => (
              <option key={lvl} value={lvl}>
                {lvl}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Language</label>
          <select
            name="language"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            required
          >
            <option value="">Select Language</option>
            {languages.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Upload Thumbnail</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />
          <p className='price-note'>Make sure the thumbnail includes the keywords from the course title.  If it doesn't, it will be rejected</p>
          {imagePreview && (
            <div>
              <h4>Image Preview:</h4>
              <img src={imagePreview} alt="thumbnail Preview" className='uploaded-preview' />
            </div>
          )}
        </div>

        {sections.map((section, sectionIndex) => (
          <div
            key={sectionIndex}
            className={`section-container ${activeSectionIndex === sectionIndex ? 'active-section' : ''}`}
            onClick={() => setActiveSectionIndex(sectionIndex)}
          >
            <h3>Section {sectionIndex + 1}</h3>
            <input
              type="text"
              placeholder="Section Title"
              value={section.sectionTitle}
              onChange={(e) => {
                const newSections = [...sections];
                newSections[sectionIndex].sectionTitle = e.target.value;
                setSections(newSections);
              }}
              required
            />
            {section.lessons.map((lesson, lessonIndex) => (
              <div key={lessonIndex} className="video-input-container">
                <input
                  type="text"
                  placeholder="Video Title"
                  name="title"
                  value={lesson.title}
                  onChange={(e) => {
                    const newSections = [...sections];
                    newSections[sectionIndex].lessons[lessonIndex].title = e.target.value;
                    setSections(newSections);
                  }}
                  required
                />
                <p className='price-note'>Ensure that the video covers important keywords related to the course, and that these keywords are included in the video title as well. If they are not, the video will be rejected</p>

                <input
                  type="file"
                  name="video"
                  accept="video/*"
                  onChange={(e) => handleVideoChange(sectionIndex, lessonIndex, e)}
                  required
                />  <button
                  type="button"
                  className="remove-video-btn"
                  onClick={() => handleRemoveLesson(sectionIndex, lessonIndex)}
                >
                  Remove Lesson

                </button>
                {lesson.videoPreview && (
                  <div>
                    <h4>Video Preview:</h4>
                    <video
                      key={lesson.videoPreview}
                      width="300"
                      controls
                      className="uploaded-preview"
                    >
                      <source src={lesson.videoPreview} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}

              </div>
            ))}
            <button
              type="button"
              onClick={() => handleAddLesson(sectionIndex)} className='add-remove-course-btn'
            >
              Add Lesson
            </button>
            <button
              type="button"
              onClick={() => handleRemoveSection(sectionIndex)} className='add-remove-course-btn'
            >
              Remove Section
            </button>
          </div>
        ))}


        <button type="button" onClick={handleAddSection} className='add-another-course-btn'>
          Add Another Section
        </button>

        <div className="question-container">
          <h3>Mandatory: Add at least 2 Quizzes</h3>

          {questions.map((q, qIndex) => (
            <div key={qIndex} className="question-container">
              <div className='quiz-question-creation'>
                <label>{t('EnterYourQuestion')}</label>
                <input
                  type="text"
                  placeholder={t('Question')}
                  value={q.question}
                  onChange={(e) => handleQuestionChange(qIndex, e)}
                  required
                />
              </div>

              <label>{t('Provide4AnswerOptions')}</label>
              {q.answers.map((a, aIndex) => (
                <div key={aIndex} className="answer-container">
                  <input
                    type="text"
                    placeholder={t('Answer')}
                    value={a.answer}
                    onChange={(e) => handleAnswerChange(qIndex, aIndex, e)}
                    required
                  />
                  <label>
                    <input
                      type="radio"
                      name={`correctAnswer${qIndex}`}
                      checked={a.correct}
                      onChange={() => handleCorrectAnswerChange(qIndex, aIndex)}
                      className='quiz-radio-creation'
                    />
                    {t('Correct')}
                  </label>
                </div>
              ))}
              <button type="button" onClick={() => handleRemoveQuestion(qIndex)} className='remove-question-btn'>
                {t('RemoveQuestion')}
              </button>
            </div>
          ))}

          <button type="button" onClick={handleAddQuestion} className='add-question-btn'>
            {t('AddAnotherQuestion')}
          </button>

        </div>

        <button type="button" onClick={handleOpenConfirmationPopup} className='add-another-course-btn'>
          Submit Course
        </button>
      </form>


      {confirmationPopup && (
        <div className="confirmation-overlay">
          <div className="confirmation-popup">
            <button className="close-btn-one" onClick={() => setConfirmationPopup(false)}>
              X
            </button>
            <h3>Are you sure you want to submit the course? Once submitted, it cannot be edited.</h3>

            <div className="button-group">
              <button className="submit-btn" onClick={() => handleCloseConfirmationPopup(true)}>
                Submit
              </button>

              <div className="tooltip-container">
                <button
                  className="draft-btn"
                  onClick={() => handleCloseConfirmationPopup(false)}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  Save as Draft
                </button>

                {showTooltip && (
                  <span className="tooltip">
                    Course will be uploaded and can be edited at your portal
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}


      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Course Added Successfully</h2>
            <div className="modal-buttons">
              <button onClick={handleCancelQuizCreation}>Go to Dashboard</button>
            </div>
          </div>
        </div>
      )}

      {/* <QuizConfirmModal
        isOpen={showModal}
        title={'QuizCreation'}
        message={'Create Quizzes for the Course'}
        onConfirm={handleConfirmQuizCreation}
        onCancel={handleCancelQuizCreation}
      /> */}

    </div>
  );
};

export default AddCourse;